import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  updateTitle,
  updateCategory,
  updateSlug,
  updateTagline,
  updateYtVideoLink1,
  updateYtVideoLink2,
  updateYtVideoLink3,
  updateFeatureImage,
  updateTechnologies,
  updatePlatform,
  updateIndustry,
  updateCountry,
  updateFirstDesc,
  updateDescImage1,
  updateDescImage2,
  updateDescImage3,
  updateDescImage4,
  updateHighlightImage,
  updateMetaTitle,
  updateMetaDescription,
} from "../redux/portfolio/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
export default function EditPortfolio() {
  let { id } = useParams();
  const [data, setData] = useState("");
  const dispatch = useDispatch();
  const fetchTechnologies = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/technologie`, {
        method: "GET",
      });
      const techData = await res.json();
      if (techData.statusCode === 200) {
        setAvailableTechnologies(techData.data);
      } else {
        console.error("Failed to fetch technologies:", techData.message);
      }
    } catch (error) {
      console.error("Error fetching technologies:", error.message);
    }
  };
  useEffect(() => {
    fetch(`${BASE_URL}/api/portfolio/getposts?postId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        const normalizedFeatureImage = Array.isArray(data[0].featureImage)
          ? data[0].featureImage
          : data[0].featureImage
          ? [data[0].featureImage]
          : [];
        dispatch(updateTitle(data[0].name));
        dispatch(updateCountry(data[0].country));
        dispatch(updateTagline(data[0].taglineDesc));
        dispatch(updateCategory(data[0].category));
        dispatch(updatePlatform(data[0].platform));
        dispatch(updateIndustry(data[0].industry));
        dispatch(updateFirstDesc(data[0].firstdescription));
        dispatch(updateYtVideoLink1(data[0].youtube1 || ""));
        dispatch(updateYtVideoLink2(data[0].youtube2 || ""));
        dispatch(updateYtVideoLink3(data[0].youtube3 || ""));
        dispatch(updateSlug(data[0].slug));
        dispatch(updateDescImage1(data[0].projectImg1 || ""));
        dispatch(updateDescImage2(data[0].projectImg2 || ""));
        dispatch(updateDescImage3(data[0].projectImg3 || ""));
        dispatch(updateDescImage4(data[0].projectImg4 || ""));
        dispatch(updateFeatureImage(normalizedFeatureImage));
        dispatch(
          updateTechnologies(
            data[0].technologies?.map((tech, idx) => ({
              index: tech.index || idx + 1,
              name: typeof tech === "string" ? tech : tech.name || "",
              image: tech.image || "",
            })) || []
          )
        );
        dispatch(updateHighlightImage(data[0].highlightImage || ""));
        dispatch(updateMetaTitle(data[0].metaTitle || ""));
        dispatch(updateMetaDescription(data[0].metaDescription || ""));
        fetchTechnologies();
        setData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, dispatch]);

  const {
    slug,
    category,
    title,
    tagline,
    featureImage,
    technologies,
    platform,
    industry,
    country,
    firstDescription,
    youtube1,
    youtube2,
    youtube3,
    descImage1,
    descImage2,
    descImage3,
    descImage4,
    highlightImage,
    metaTitle,
    metaDescription,
  } = useSelector((state) => state.portfolio);

  // Form validation error state
  const [formerror, setFormError] = useState({});
  // Feature image API states
  const [featureImgError, setFeatureImgError] = useState("");
  const [featureimageUploadState, setFeatureImageUploadState] = useState("");
  // Highlight image API states
  const [highlightImgError, setHighlightImgError] = useState("");
  const [highlightImgUploadState, setHighlightImgUploadState] = useState("");
  // Description image API states
  const [descImage1Err, setdescImage1Err] = useState("");
  const [descImage1State, setdescImage1State] = useState("");
  const [descImage2Err, setdescImage2Err] = useState("");
  const [descImage2State, setdescImage2State] = useState("");
  const [descImage3Err, setdescImage3Err] = useState("");
  const [descImage3State, setdescImage3State] = useState("");
  const [descImage4Err, setdescImage4Err] = useState("");
  const [descImage4State, setdescImage4State] = useState("");

  // Technologies Part
  const [inputValue, setInputValue] = useState("");
  const [selectedTechId, setSelectedTechId] = useState("");
  const [availableTechnologies, setAvailableTechnologies] = useState([]);
  // API handling States
  const [publishError, setPublishError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(false);

  const handleInputChange = (e) => setInputValue(e.target.value);

  const handleAddTechnology = () => {
    if (selectedTechId) {
      const selectedTech = availableTechnologies.find(
        (tech) => tech._id === selectedTechId
      );
      if (selectedTech) {
        const newTech = {
          index: technologies.length + 1,
          name: selectedTech.name,
          image: selectedTech.image,
        };
        dispatch(updateTechnologies([...technologies, newTech]));
        setSelectedTechId("");
      }
    }
  };

  const handleDeleteTechnology = (index) => {
    const updatedTechList = technologies
      .filter((_, i) => i !== index)
      .map((tech, idx) => ({ ...tech, index: idx + 1 })); // <--- +1 here
    dispatch(updateTechnologies(updatedTechList));
  };

  const handleFeatureImgChange = async (event) => {
    setFeatureImageUploadState("Uploading Images...");
    const files = Array.from(event.target.files); // Handle multiple files
    const uploadPromises = files.map(async (selectedFile) => {
      if (!selectedFile.type.startsWith("image/")) {
        setFeatureImgError("Please Upload Image Files Only.");
        setFeatureImageUploadState("");
        return null;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            return data.url.substring(0, indexOfQuestionMark);
          }
        }
      } catch (error) {
        setFeatureImgError(error.message);
        setFeatureImageUploadState("");
        return null;
      }
    });

    try {
      const uploadedUrls = (await Promise.all(uploadPromises)).filter(
        (url) => url
      );
      if (uploadedUrls.length > 0) {
        const newFeatureImages = [...featureImage, ...uploadedUrls];
        dispatch(updateFeatureImage(newFeatureImages));
        setFeatureImageUploadState("Images Uploaded!");
      } else {
        setFeatureImageUploadState("");
      }
    } catch (error) {
      setFeatureImgError(error.message);
      setFeatureImageUploadState("");
    }
  };

  const handleRemoveFeatureImage = (index) => {
    const updatedImages = featureImage.filter((_, i) => i !== index);
    dispatch(updateFeatureImage(updatedImages));
  };

  // Added highlight image handling functions
  const handleHighlightImgChange = async (event) => {
    setHighlightImgUploadState("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setHighlightImgError("Please Upload Image File.");
        setHighlightImgUploadState("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setHighlightImgUploadState("Image Uploaded!");
            dispatch(updateHighlightImage(originalUrl));
          }
        }
      } catch (error) {
        setHighlightImgError(error.message);
        setHighlightImgUploadState("");
      }
    }
  };

  const handleRemoveHighlightImage = () => {
    dispatch(updateHighlightImage(""));
    setHighlightImgUploadState("");
  };

  const handledescImage1 = async (event) => {
    setdescImage1State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage1Err("Please Upload Image File.");
        setdescImage1State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage1State("Image Uploaded!");
            dispatch(updateDescImage1(originalUrl));
          }
        }
      } catch (error) {
        setdescImage1Err(error.message);
        setdescImage1State("");
      }
    }
  };

  const handleRemoveDescImage1 = () => {
    dispatch(updateDescImage1(""));
    setdescImage1State("");
  };

  const handledescImage2 = async (event) => {
    setdescImage2State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage2Err("Please Upload Image File.");
        setdescImage2State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage2State("Image Uploaded!");
            dispatch(updateDescImage2(originalUrl));
          }
        }
      } catch (error) {
        setdescImage2Err(error.message);
        setdescImage2State("");
      }
    }
  };

  const handleRemoveDescImage2 = () => {
    dispatch(updateDescImage2(""));
    setdescImage2State("");
  };

  const handledescImage3 = async (event) => {
    setdescImage3State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage3Err("Please Upload Image File.");
        setdescImage3State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage3State("Image Uploaded!");
            dispatch(updateDescImage3(originalUrl));
          }
        }
      } catch (error) {
        setdescImage3Err(error.message);
        setdescImage3State("");
      }
    }
  };

  const handleRemoveDescImage3 = () => {
    dispatch(updateDescImage3(""));
    setdescImage3State("");
  };

  const handledescImage4 = async (event) => {
    setdescImage4State("Uploading Image...");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.startsWith("image/")) {
        setdescImage4Err("Please Upload Image File.");
        setdescImage4State("");
        event.target.value = "";
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/api/blog/getuploadurl`, {
          method: "GET",
        });
        const data = await res.json();
        if (data.url) {
          const uploadRes = await fetch(data.url, {
            method: "PUT",
            body: selectedFile,
          });
          if (uploadRes.ok) {
            const indexOfQuestionMark = data.url.indexOf("?");
            const originalUrl = data.url.substring(0, indexOfQuestionMark);
            setdescImage4State("Image Uploaded!");
            dispatch(updateDescImage4(originalUrl));
          }
        }
      } catch (error) {
        setdescImage4Err(error.message);
        setdescImage4State("");
      }
    }
  };

  const handleRemoveDescImage4 = () => {
    dispatch(updateDescImage4(""));
    setdescImage4State("");
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "text-align", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const validation = () => {
    let err = {};
    if (title === "") err.portfolio_title = "Please Enter Title.";
    if (featureImage.length === 0)
      err.featureImage = "Please Upload at least one Feature Image.";
    if (!highlightImage)
      err.highlightImage = "Please Upload a Highlight Image.";
    if (slug === "") err.slug = "Please Enter Slug.";
    if (tagline === "") err.tagline = "Please Enter tagline content.";
    if (technologies.length === 0)
      err.technologies = "Please Enter at least one Technology.";
    if (platform === "") err.platform = "Please Enter platform content.";
    if (industry === "") err.industry = "Please Enter industry content.";
    if (country === "") err.country = "Please Enter country content.";
    if (firstDescription === "")
      err.firstDescription = "Please Enter firstDescription content.";
    if (!metaTitle.trim()) err.metaTitle = "Please enter a Meta Title.";
    if (!metaDescription.trim())
      err.metaDescription = "Please enter a Meta Description.";

    if (
      !category ||
      (Array.isArray(category) && category.length === 0) ||
      (!Array.isArray(category) && category === "")
    ) {
      err.category = "Please select at least one category.";
    }
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleSubmit = async () => {
    let isvalid = validation();
    if (isvalid) {
      try {
        console.log("Feature Image before API request:", featureImage);
        console.log("Highlight Image before API request:", highlightImage);
        const res = await fetch(`${BASE_URL}/api/portfolio/updatepost/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: title,
            slug: slug,
            featureImage: featureImage,
            highlightImage: highlightImage,
            category: category,
            taglineDesc: tagline,
            technologies: technologies,
            platform: platform,
            industry: industry,
            country: country,
            firstdescription: firstDescription,
            youtube1: youtube1,
            youtube2: youtube2,
            youtube3: youtube3,
            projectImg1: descImage1,
            projectImg2: descImage2,
            projectImg3: descImage3,
            projectImg4: descImage4,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
          }),
        });
        const data = await res.json();
        console.log(data);
        if (!res.ok) {
          setPublishError(data.message);
          return;
        }
        if (res.ok) {
          setPublishError(null);
          setSuccessMsg(true);
        }
      } catch (error) {
        setPublishError(error.message);
      }
    }
  };

  return (
    <div>
      {data && (
        <div className="container">
          <div className="blogadminform">
            <div>
              <h6 className="mt-2">Portfolio Title</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Portfolio Title"
                name="portfolio_title"
                onChange={(e) => dispatch(updateTitle(e.target.value))}
                value={title}
              />
              <span className="formhandle">{formerror.portfolio_title}</span>
            </div>
            <div>
              <h6 className="mt-2">Meta Title</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter Meta Title"
                onChange={(e) => dispatch(updateMetaTitle(e.target.value))}
                value={metaTitle}
              />
              <span className="formhandle">{formerror.metaTitle}</span>
            </div>
            <div>
              <h6 className="mt-2">Meta Description</h6>
              <textarea
                rows={3}
                className="formitem"
                placeholder="Enter Meta Description"
                onChange={(e) =>
                  dispatch(updateMetaDescription(e.target.value))
                }
                value={metaDescription}
              />
              <span className="formhandle">{formerror.metaDescription}</span>
            </div>
            <div>
              <h6 className="mt-2">Portfolio Tagline</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter Tagline"
                name="tagline"
                onChange={(e) => dispatch(updateTagline(e.target.value))}
                value={tagline}
              />
              <span className="formhandle">{formerror.tagline}</span>
            </div>
            <div>
              <h6 className="mt-2">Upload Highlight Image</h6>
              <input type="file" onChange={handleHighlightImgChange} />
              <span className="formhandle">
                {formerror.highlightImage}
                <br />
                {highlightImgError ? highlightImgError : ""}
              </span>
              {highlightImage ? (
                <div>
                  <h6 className="mt-2">Preview:</h6>
                  <img
                    src={highlightImage}
                    alt="Uploaded Highlight"
                    style={{ maxWidth: "200px", maxHeight: "200px" }}
                  />
                  <button
                    onClick={handleRemoveHighlightImage}
                    style={{ display: "block", marginTop: "5px" }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="loading">{highlightImgUploadState}</div>
              )}
            </div>
            <div>
              <h6 className="mt-2">Upload Feature Images (Multiple Allowed)</h6>
              <input type="file" multiple onChange={handleFeatureImgChange} />
              <span className="formhandle">
                {formerror.featureImage}
                <br />
                {featureImgError ? featureImgError : ""}
              </span>
              {featureImage.length > 0 ? (
                <div>
                  <h6 className="mt-2">Previews:</h6>
                  {featureImage.map((img, index) => (
                    <div
                      key={index}
                      style={{ display: "inline-block", margin: "10px" }}
                    >
                      <img
                        src={img}
                        alt={`Uploaded ${index}`}
                        style={{ maxWidth: "200px", maxHeight: "200px" }}
                      />
                      <button
                        onClick={() => handleRemoveFeatureImage(index)}
                        style={{ display: "block", marginTop: "5px" }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="loading">{featureimageUploadState}</div>
              )}
            </div>
            <div>
              <h6 className="mt-2">Category (Multiple Selection)</h6>
              <div>
                {[
                  { value: "web", label: "Web" },
                  { value: "mobile", label: "Mobile" },
                  { value: "ai-ml", label: "AI/ML" },
                  { value: "iot", label: "IOT" },
                  { value: "ar", label: "Augmented Reality" },
                  { value: "unity", label: "Unity 3D" },
                ].map((option) => (
                  <div key={option.value}>
                    <input
                      type="checkbox"
                      id={option.value}
                      value={option.value}
                      checked={
                        Array.isArray(category)
                          ? category.includes(option.value)
                          : category === option.value
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        const isChecked = e.target.checked;

                        const currentCategories = Array.isArray(category)
                          ? category
                          : category
                          ? [category]
                          : [];

                        let updatedCategories;
                        if (isChecked) {
                          updatedCategories = currentCategories.includes(value)
                            ? currentCategories
                            : [...currentCategories, value];
                        } else {
                          updatedCategories = currentCategories.filter(
                            (cat) => cat !== value
                          );
                        }

                        dispatch(updateCategory(updatedCategories));
                      }}
                    />
                    <label htmlFor={option.value}>{option.label}</label>
                  </div>
                ))}

                {Array.isArray(category) && category.length > 0 && (
                  <div>
                    <h6>Selected Categories:</h6>
                    <div>
                      {category.map((cat, index) => (
                        <span key={index}>
                          {cat}
                          <button
                            type="button"
                            onClick={() => {
                              const updatedCategories = category.filter(
                                (c) => c !== cat
                              );
                              dispatch(updateCategory(updatedCategories));
                            }}
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <span className="formhandle">{formerror.category}</span>
            </div>
            <div className="instruction">
              <ul>
                <li>
                  Slug is the URL Path name in which The blog will be rendered.
                </li>
                <li>https://betasource.tech/portfolio/[slug-name]</li>
                <li>
                  There should be No-space, No capital letter in the slug name
                </li>
                <li>you can use hyphen(-) instead of space.</li>
              </ul>
            </div>
            <div>
              <h6 className="mt-2">Enter Slug</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter the Slug"
                name="slug"
                onChange={(e) => dispatch(updateSlug(e.target.value))}
                value={slug}
              />
              <span className="formhandle">{formerror.slug}</span>
            </div>
            <div>
              <h6 className="mt-2">Select Technologies</h6>
              <select
                className="formitem"
                value={selectedTechId}
                onChange={(e) => setSelectedTechId(e.target.value)}
              >
                <option value="">Select a Technology</option>
                {availableTechnologies.map((tech) => (
                  <option key={tech._id} value={tech._id}>
                    {tech.name}
                  </option>
                ))}
              </select>
              <button onClick={handleAddTechnology}>Add</button>
              <span className="formhandle">{formerror.technologies}</span>
              <ul>
                {technologies.map((tech, index) => (
                  <li key={index}>
                    {tech.name} (Index: {tech.index})
                    {tech.image && (
                      <img
                        src={tech.image}
                        alt={tech.name}
                        style={{
                          maxWidth: "50px",
                          maxHeight: "50px",
                          marginLeft: "10px",
                        }}
                      />
                    )}
                    <button onClick={() => handleDeleteTechnology(index)}>
                      Delete
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h6 className="mt-2">Enter platform</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter the platform"
                name="platform"
                onChange={(e) => dispatch(updatePlatform(e.target.value))}
                value={platform}
              />
              <span className="formhandle">{formerror.platform}</span>
            </div>
            <div>
              <h6 className="mt-2">Enter Industry</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter the industry"
                name="industry"
                onChange={(e) => dispatch(updateIndustry(e.target.value))}
                value={industry}
              />
              <span className="formhandle">{formerror.industry}</span>
            </div>
            <div>
              <h6 className="mt-2">Enter Country</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter the country"
                name="country"
                onChange={(e) => dispatch(updateCountry(e.target.value))}
                value={country}
              />
              <span className="formhandle">{formerror.country}</span>
            </div>
            <div className="blog-content">
              <h6 className="mt-2">Enter firstDescription-About Client</h6>
              <ReactQuill
                theme="snow"
                modules={modules}
                formats={formats}
                onChange={(value) => dispatch(updateFirstDesc(value))}
                value={firstDescription}
                placeholder="Enter the firstDescription"
              />
              <span className="formhandle">{formerror.firstDescription}</span>
            </div>
            <div>
              <h6 className="mt-2">Enter youtube video links</h6>
              <input
                type="text"
                className="formitem"
                placeholder="Enter the Youtube link 1"
                name="ytvideolink1"
                onChange={(e) => dispatch(updateYtVideoLink1(e.target.value))}
                value={youtube1}
              />
              <input
                type="text"
                className="formitem"
                placeholder="Enter the Youtube link 2"
                name="ytvideolink2"
                onChange={(e) => dispatch(updateYtVideoLink2(e.target.value))}
                value={youtube2}
              />
              <input
                type="text"
                className="formitem"
                placeholder="Enter the Youtube link 3"
                name="ytvideolink3"
                onChange={(e) => dispatch(updateYtVideoLink3(e.target.value))}
                value={youtube3}
              />
            </div>
            <div>
              <h6 className="mt-2">
                Upload the Description Image -1 of Portfolio
              </h6>
              <input type="file" onChange={handledescImage1} />
              <span className="formhandle">
                {descImage1Err ? descImage1Err : ""}
              </span>
              {descImage1 ? (
                <div>
                  <h6 className="mt-2">Preview:</h6>
                  <img
                    src={descImage1}
                    alt="Uploaded"
                    style={{ maxWidth: "400px", maxHeight: "400px" }}
                  />
                  <button
                    onClick={handleRemoveDescImage1}
                    style={{ marginTop: "5px" }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="loading">{descImage1State}</div>
              )}
            </div>
            <div>
              <h6 className="mt-2">
                Upload the Description Image -2 of Portfolio
              </h6>
              <input type="file" onChange={handledescImage2} />
              <span className="formhandle">
                {descImage2Err ? descImage2Err : ""}
              </span>
              {descImage2 ? (
                <div>
                  <h6 className="mt-2">Preview:</h6>
                  <img
                    src={descImage2}
                    alt="Uploaded"
                    style={{ maxWidth: "400px", maxHeight: "400px" }}
                  />
                  <button
                    onClick={handleRemoveDescImage2}
                    style={{ marginTop: "5px" }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="loading">{descImage2State}</div>
              )}
            </div>
            <div>
              <h6 className="mt-2">
                Upload the Description Image -3 of Portfolio
              </h6>
              <input type="file" onChange={handledescImage3} />
              <span className="formhandle">
                {descImage3Err ? descImage3Err : ""}
              </span>
              {descImage3 ? (
                <div>
                  <h6 className="mt-2">Preview:</h6>
                  <img
                    src={descImage3}
                    alt="Uploaded"
                    style={{ maxWidth: "400px", maxHeight: "400px" }}
                  />
                  <button
                    onClick={handleRemoveDescImage3}
                    style={{ marginTop: "5px" }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="loading">{descImage3State}</div>
              )}
            </div>
            <div>
              <h6 className="mt-2">
                Upload the Description Image -4 of Portfolio
              </h6>
              <input type="file" onChange={handledescImage4} />
              <span className="formhandle">
                {descImage4Err ? descImage4Err : ""}
              </span>
              {descImage4 ? (
                <div>
                  <h6 className="mt-2">Preview:</h6>
                  <img
                    src={descImage4}
                    alt="Uploaded"
                    style={{ maxWidth: "400px", maxHeight: "400px" }}
                  />
                  <button
                    onClick={handleRemoveDescImage4}
                    style={{ marginTop: "5px" }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="loading">{descImage4State}</div>
              )}
            </div>
            <button onClick={handleSubmit} className="formbtn">
              Update
            </button>
            {publishError && <div className="formhandle">{publishError}</div>}
            {successMsg && (
              <div className="success">Post Updated Successfully!</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
